// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box } from 'components';
import React, { ReactElement } from 'react';
import './qualificationsTransport.scss';
import { useTranslation } from 'react-i18next';
import {
  TransportDangerousGoodsModel,
  TransportDriverLicenseModel,
} from 'api/types/Transport';
import TransportDriverLicense from './TransportDriverLicense';
import DangerousGoods from './DangerousGoods';

interface Props {
  userId: number | null;
  dataTransportDangerousGoods:
    | TransportDangerousGoodsModel[]
    | null
    | undefined;
  dataTransportDriverLicense: TransportDriverLicenseModel[] | null | undefined;
}

const TransportPanel = (props: Props): ReactElement => {
  const { userId, dataTransportDangerousGoods, dataTransportDriverLicense } =
    props;
  const { t } = useTranslation('employee');

  return (
    <>
      {(dataTransportDriverLicense && dataTransportDriverLicense.length > 0) ||
      (dataTransportDangerousGoods &&
        dataTransportDangerousGoods.length > 0) ? (
        <Box
          id="userTransportBox"
          name={t('userTransport.transport')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <TransportDriverLicense
            userId={userId}
            dataTransportDriverLicense={dataTransportDriverLicense}
          />
          <DangerousGoods
            userId={userId}
            dataTransportDangerousGoods={dataTransportDangerousGoods}
          />
        </Box>
      ) : (
        ''
      )}
    </>
  );
};

export default TransportPanel;
